const AccountingIdValues = {
    PayableAccount: "2420",
    BuypassAccount: "1770",
    BankAccount: "1920"
};

Object.freeze(AccountingIdValues);

export default AccountingIdValues;
